import { render } from "./OrdersPage.vue?vue&type=template&id=5238da04&ts=true"
import script from "./OrdersPage.vue?vue&type=script&lang=ts"
export * from "./OrdersPage.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./OrdersPage.vue?vue&type=style&index=0&id=5238da04&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__